export const MY_SECTIONS = "/access/me"
export const ACCESS_OVERVIEW = "/access/overview"
export const ACCESS_DESIGNATION = "/access/designation"
export const ACCESS_OFFICERS = "/access/officers"
export const ACCESS_OVERRIDE = "/access/override"
